export const AppString = {
    QNA: 'qna-bd',
    QNAREPLY: 'qnaReply',
    PollAdmin_Col: 'pollAdmin',
    Poll_Doc: 'poll',
    PollAdmin_Doc: 'adminAccess',

    Dailyco_Doc: '',
    Dailyco_Col: 'dailyco',
    Dailyco_Col_test: 'dailyco-test',


    BACKSTAGE: 'backStage',
    BACKSATGE: 'backStage',
    BACKSTAGELINK: 'staticData',
    BACKSTAGEREALTIMEDATA: 'realtimeData',

    MEETINGROOMMESSAGE: 'meetingRoomMessage',
    MEETINGROOM: 'meetingRoom',
    MEETINGROOMDOC: '1_Ultra-Tech',
    MEETINGROOMCUSTOM: 'meetingRoomCutom',

    CONNECT: 'connect',
}
